import { SubscriptionItemType } from "../../../types";

import { messages } from "./SubscriptionsItemsTree.messages";

export const SUBSCRIPTION_ITEMS_GROUPS = [
  {
    id: `slide`,
    name: messages.slidesGroup,
    type: SubscriptionItemType.Slide,
  },
  {
    id: `bulk-export`,
    name: messages.bulkExportGroup,
    type: SubscriptionItemType.BulkExport,
  },
  {
    id: `saved-bulk-export`,
    name: messages.savedBulkExportGroup,
    type: SubscriptionItemType.SavedBulkExport,
  },
] as const;
